import { h } from "@stencil/core";
import { tableClass } from "../constants";
export const TableDataCell = ({ group = false, empty = false, sort = null, multiline = false }, children) => (h("td", { class: {
        [`${tableClass}__td`]: true,
        [`${tableClass}__td--multiline`]: multiline
    }, "data-sort": sort }, h("div", { class: {
        [`${tableClass}__cell`]: true,
        [`${tableClass}__cell--no-data`]: empty,
        [`${tableClass}__cell--group`]: group
    } }, children)));
//# sourceMappingURL=table-data-cell.js.map
